import {
  ROSREESTR_DATA_VISIBILITY_EXPERIMENT,
  NEWBUILDING_WINNER_EXPERIMENT,
  WEB_3D_TOURS_EXPERIMENT,
  INFRASTRUCTURE_MF_EXPERIMENT,
  CALLBACK_BUTTON_TEXT_EXPERIMENT,
} from 'shared/selectors/abExperiments';

import { CALLTRACKING_WARNING } from '../../experiments/calltrackingWarning';
import { HOUSE_CARD_URL_EXPERIMENT } from '../../utils/experiments/houseCardUrl';

export const EXPERIMENTS: string[] = [
  HOUSE_CARD_URL_EXPERIMENT,
  CALLTRACKING_WARNING,
  NEWBUILDING_WINNER_EXPERIMENT,
  INFRASTRUCTURE_MF_EXPERIMENT,
  WEB_3D_TOURS_EXPERIMENT,
  CALLBACK_BUTTON_TEXT_EXPERIMENT,
  ROSREESTR_DATA_VISIBILITY_EXPERIMENT,
];
